import 'bootstrap/dist/css/bootstrap.min.css';
import './styles.css';
import React, { Suspense, lazy } from 'react';
import ReactDOM from 'react-dom/client';
import './utils/antdReact19';

import { isControlHost } from './utils/isControlHost';
import { isMarketingHost } from './utils/isMarketingHost';
import { configurePwaForHost } from './pwa/serviceWorkerRegistration';

const TenantRoot = lazy(() => import('./TenantRoot'));
const ControlRoot = lazy(() => import('./control/ControlRoot'));
const MarketingRoot = lazy(() => import('./MarketingRoot'));
const ActionFeedbackHost = lazy(() => import('./components/ActionFeedbackHost'));

function RootLoader() {
  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'grid',
        placeItems: 'center',
        background: 'linear-gradient(180deg, #f6f8fb 0%, #eef2f7 100%)',
      }}
    >
      <div
        style={{
          width: 44,
          height: 44,
          borderRadius: '50%',
          border: '4px solid rgba(17, 24, 39, 0.14)',
          borderTopColor: '#111827',
          animation: 'srms-spin 0.85s linear infinite',
        }}
      />
    </div>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
const controlHost = isControlHost();
const marketingHost = isMarketingHost();
const tenantHost = !controlHost && !marketingHost;
const SelectedRoot = controlHost ? ControlRoot : marketingHost ? MarketingRoot : TenantRoot;

void configurePwaForHost({ tenantHost });

root.render(
  <>
    <Suspense fallback={null}><ActionFeedbackHost /></Suspense>
    <style>{'@keyframes srms-spin { to { transform: rotate(360deg); } }'}</style>
    <Suspense fallback={<RootLoader />}>
      <SelectedRoot />
    </Suspense>
  </>
);
